// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"687":"ba5489fd","833":"ce24cf6c"}[chunkId] + ".js";
};